import {
  ref,
  computed,
  inject,
} from '@vue/composition-api';
import ouibounce from 'ouibounce';

export default (props, context) => {
  const {
    brokerShownResults,
    brokerResults,
    resultsPageLayout,
    isQuotesLoading,
    resultsPageDisplay,
    shownResults,
    quotesQuantity,
  } = props;

  const config = inject('config');
  // DATA
  // this flag needs to display a modal if:
  // 1) it's a partner with enabled Broker Solution;
  // 2) partner selected ExitOnly option for Results page layout;
  // 3) there is no broker results and user tries to close a tab
  const isBrokerSolutionModalShowed = ref(false);

  // COMPUTED
  const isBrokerSolutionEnabled = computed(() => {
    return config.enableBrokerSolution || false;
  });
  const hasBrokerResults = computed(() => {
    return !!(brokerShownResults.value && brokerResults.value.length);
  });
  const isBrokerSolutionShown = computed(() => {
    return resultsPageLayout.value !== 'default' && isBrokerSolutionEnabled.value;
  });
  const isBrokerSolutionMessageShown = computed(() => {
    return isBrokerSolutionShown.value && !isQuotesLoading.value;
  });
  const isBrokerSolutionTableShown = computed(() => {
    return isBrokerSolutionShown.value && hasBrokerResults.value;
  });
  const isQZShown = computed(() => {
    return resultsPageLayout.value !== 'brokerOnly';
  });
  const isExitModalShown = computed(() => {
    return resultsPageLayout.value === 'brokerOnly' && resultsPageDisplay.value === 'Exit Click Display';
  });
  const isQZShownMessageShown = computed(() => {
    return isQZShown.value;
  });
  const isAdditionalResultsCTAShown = computed(() => {
    return isBrokerSolutionEnabled.value &&
      resultsPageLayout.value === 'brokerOnly' &&
      resultsPageDisplay.value === 'Broker Pricing With QZ Option';
  });
  const totalCount = computed(() => {
    if (!isBrokerSolutionEnabled.value) {
      return quotesQuantity.value;
    }

    switch (resultsPageLayout.value) {
      case 'brokerOnly':
        return brokerShownResults.value.length;
      case 'both':
        return brokerShownResults.value.length + quotesQuantity.value;
      default:
        return quotesQuantity.value;
    }
  });
  const shownResultsCheapestPrice = computed(() => {
    if (!quotesQuantity.value) return 0;
    return shownResults.value[0].details[0].calcAnnual; // get the smallest price
  });

  // METHODS
  const initExitOnlyModal = () => {
    if (isExitModalShown.value) {
      ouibounce(false, {
        aggressive: true,
        callback: showBrokerSolutionModal,
      });
    }
  };
  const showBrokerSolutionModal = () => {
    isBrokerSolutionModalShowed.value = true;
  };
  const onBrokerSolutionModalCancel = () => {
    isBrokerSolutionModalShowed.value = false;
  };
  const onBrokerSolutionModalSuccess = () => {
    isBrokerSolutionModalShowed.value = false;
    resultsPageLayout.value = 'both';
  };

  return {
    hasBrokerResults,
    initExitOnlyModal,
    isAdditionalResultsCTAShown,
    isBrokerSolutionEnabled,
    isBrokerSolutionMessageShown,
    isBrokerSolutionModalShowed,
    isBrokerSolutionShown,
    isBrokerSolutionTableShown,
    isQZShown,
    isQZShownMessageShown,
    onBrokerSolutionModalCancel,
    onBrokerSolutionModalSuccess,
    showBrokerSolutionModal,
    shownResultsCheapestPrice,
    totalCount,
  };
};
